import { appConfig } from "cd-eft/config/AppConfig";

const doEvents = () => {
    return pause(0);
}
const pause = (t) => {
    const promise = new Promise<void>(
        (resolve, reject) => {
            setTimeout(
                () => {
                    resolve();
                }, t);
        });
    return promise;
}

export { doEvents }


export const getAppVersion = (level: "major" | "minor" | "revision" | "patch") => {
    // Format: major.minor.revision.patch
    let resultVersion = '';
    const arr = appConfig.releaseVersion.split('.');
    switch (level) {
        case "major":
            resultVersion = arr[0];
            break
        case "minor":
            resultVersion = `${arr[0]}.${arr[1]}`
            break
        case "revision":
            resultVersion = `${arr[0]}.${arr[1]}.${arr[2]}`
            break
        case "patch":
        default:
            resultVersion = appConfig.releaseVersion;
    }
    return resultVersion;
}